import type { ChartPeriod } from '../types';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/shadcn/select';

interface ChartPeriodSelectorProps {
  value: ChartPeriod;
  onChange: (period: ChartPeriod) => void;
}

export function ChartPeriodSelector({ value, onChange }: ChartPeriodSelectorProps) {
  return (
    <Select value={value} onValueChange={(value) => onChange(value as ChartPeriod)}>
      <SelectTrigger>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="daily">Daily</SelectItem>
        <SelectItem value="weekly">Weekly</SelectItem>
        <SelectItem value="monthly">Monthly</SelectItem>
      </SelectContent>
    </Select>
  );
}
